import { useCallback } from "react";
import { createFileRoute, useNavigate, useParams } from "@tanstack/react-router";

import {
  PodsPage,
  type PodSearch,
} from "../../../workspaces/production/pages/PodsPage";
import { useSeat } from "../../../workspaces/production/seat";

/* The floor's pods, and one pod open. The pod is the address: `/production/pods/$podId`
 * is the link a floor manager sends about it. This layout renders the page; its child
 * routes only name the selection, so choosing a pod keeps the page and its local state
 * (the decommissioned toggle, the scroll position) mounted. One episode is a page of its
 * own (`pods_.$podId.$episodeId.tsx`).
 */
export const Route = createFileRoute("/_console/production/pods")({
  component: Pods,
});

function Pods() {
  const { podId } = useParams({ strict: false });
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: PodSearch) =>
      void navigate(
        next.pod === undefined
          ? { to: "/production/pods" }
          : { to: "/production/pods/$podId", params: { podId: next.pod } },
      ),
    [navigate],
  );
  return (
    <PodsPage
      role={useSeat()}
      search={{ pod: podId }}
      onSearchChange={onSearchChange}
    />
  );
}
